import './style.scss';

import { useWindowResize } from '../../hooks';

const HeaderPhoto = () => {
  const { width: windowWidth } = useWindowResize();
  const imageUrl =
    windowWidth > 768
      ? 'https://zoolife.tv/assets/login-signup-image-desktop-1.webp'
      : 'https://zoolife.tv/assets/login-signup-image-mobile-5.webp';

  return (
    <div className="headerPhoto">
      <img src={imageUrl} alt="Login Signup" />
    </div>
  );
};

export default HeaderPhoto;
